import type { PageData } from '@/types';
import * as ComponentData from './content.html';

const pageData: PageData = [
  {
    title: 'Open Methane Public Data',
    link: {
      title: 'Public Data',
      anchor: 'public-data',
    },
    blocks: [
      {
        components: [
          {
            type: 'text',
            content: ComponentData.C01,
          },
        ],
      },
    ],
  },
  {
    title: 'Data Sources',
    link: {
      title: 'Data Sources',
      anchor: 'data-sources',
    },
    blocks: [
      {
        link: {
          title: 'Open Methane Model',
          anchor: 'model-data-sources',
        },
        components: [
          {
            type: 'text',
            content: ComponentData.C02,
          },
        ],
      },
      {
        link: {
          title: 'Open Methane Web',
          anchor: 'web-data-sources',
        },
        components: [
          {
            type: 'text',
            content: ComponentData.C03,
          },
        ],
      },
    ],
  },
];

export default pageData;
